import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { actions, ACTIONS_TYPES } from 'redux/local';
import { locations } from 'utils';
import Dropdown from './select-field';
import Icon from '../icon';

export default ({
  onChange,
  value,
  validLocations,
  ...props
}) => {
  const {
    [ACTIONS_TYPES.LOCATION.GET_ALL]: locationsGlobal = [],
  } = useSelector((e) => e);

  useEffect(() => {
    actions.location.getAll();
  }, []);
  const locationsList = locationsGlobal.map(({ id: key }) => {
    if (!locations[key] || (validLocations && !validLocations.includes(key))) return false;
    return [key, (
      <div className="locations-dropdown">
        {locations[key]?.image ? (
          <img src={locations[key].image} alt={key} />
        ) : (
          <Icon name="globe-europe" style={{ fontSize: 25, marginRight: 10 }} />
        )}
        <div>
          <span>{locations[key]?.name || key}</span>
          <br />
          <span style={{
            marginTop: -5,
            display: 'block',
            fontSize: 10,
          }}
          >
            {key}
          </span>
        </div>
      </div>
    )];
  }).filter((item) => item);

  return (
    <Dropdown
      value={locationsList.length ? value : ''}
      values={locationsList}
      onChange={(e) => onChange(e.target.value)}
      {...props}
    />
  );
};
